export class AchievementManager {
  constructor(coursenum) {
    this.coursenum = coursenum
  }

  attach() {
    const self = this
    $('.table a.delete_award').on('click', function (event) {
      event.preventDefault()

      const el = $(this)
      const awardPk = el.data('awardpk')
      const name = el.data('awardname')
      const type = el.data('awardtype')

      const dialogOnYes = () => self.deleteAward(awardPk, self.coursenum, type)

      const message = `
        <p>
          This will delete everything associated with the award ${name}, including achievements already given to students.
        </p>
        <p>
          Are you sure you want to continue?
        </p>
      `

      $.meDialog.warningyesno('Delete Award', message, dialogOnYes)
    })
  }

  deleteAward = (awardId, coursenum, type) => {
    $.ajax({
      type: 'POST',
      url: `/instructor/achievements.delete_${type}/${coursenum}/`,
      data: { awardId: awardId },
      success: function () {
        var idSelector = `#${type}_${awardId}`
        $(idSelector).remove()
      },
      error: function () {
        $.meDialog.topMessage(
          `There was an error finding and deleting that ${type}`,
          4000,
          'danger'
        )
      },
    })
  }
}
